"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/EngineSize.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EngineSize = function EngineSize(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 224.4 161.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Engine Size Icon"), _react2.default.createElement("path", {
    className: "engine-size",
    d: "M213.6 60v27h-9.8v-6.3c0-11.1-6.8-18.6-16.9-18.6h-4.6c-1.2-2-3.3-5.9-5-9.1-11.3-21.1-20-36.1-29.3-36.1h-42.4v-6h32.1V0H62.9v10.9H95v6H38.3c-5.1-.1-7.8 0-12.5 4.5a16.13 16.13 0 0 0-4.6 11.8c-.2 9.6-.3 17.9-.4 25h-9.9V26H0v74.8h10.9V68.7h9.8c-.1 25.1.7 31.6 1.7 34.1 1.7 4.5 12 18.6 18 26.5 22.2 28.8 24.8 31.9 30.3 31.9h78.5c3.3 0 5.6-3.4 8.3-7.2 2.3-3.2 5.1-7.6 8.1-12.3 4.8-7.4 12.7-19.6 15.8-22.7l5.5-.2c9.9-.1 16.8-8.1 16.8-19.6v-1.5h9.8v27h10.9V60h-10.8zm-20 39.2c0 1-.2 9.4-6.7 9.4l-8.1.3-.7.3c-3.9 1.4-8.2 7.3-21 27-3.4 5.2-7.9 12.1-10 14.8H71.2c-2.6-1.9-11.5-13.3-22.8-27.9-8.3-10.7-15.7-21.7-16.5-23.8-.8-2.6-1.6-16.2-.5-65.9a6.41 6.41 0 0 1 1.5-4.6C34.7 27 34.7 27 38 27h109.8c4.9 1.5 16.2 22.7 20.5 30.7 5.1 9.6 6.6 12.4 8.8 13.7l1.2.8 8.6.1c5.8 0 6.7 5.3 6.7 8.4v18.5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = EngineSize;